import { render, staticRenderFns } from "./InputRole.vue?vue&type=template&id=1b7424e6&"
import script from "./InputRole.vue?vue&type=script&lang=js&"
export * from "./InputRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports